import React from "react";
import AppFormik from "src/commun/composants/formulaire/formik/AppFormik";
import { rattacher } from "src/app/api/FinalizationApi";
import useValidationSchemaRattachement, { Rattachement } from "src/pages/rattachement/form/useValidationSchemaRattachement";
import RattachementFormContent from "src/pages/rattachement/form/RattachementFormContent";
import { GenericApiResponse } from "src/app/api/AppApiClient";
import { FormikValues } from "formik";
import AppCol from "src/commun/composants/grille/AppCol";
import { useAppText } from "src/commun/composants/AppText";

export type RattachementFormProps = {
  sourceUid: string;
  targetEmailAddress: string;
  submitSuccessHandler: (result: GenericApiResponse<any>, values: FormikValues) => void;
};

const RattachementForm = ({ sourceUid, targetEmailAddress, submitSuccessHandler }: RattachementFormProps) => {
  const validationSchema = useValidationSchemaRattachement();
  const { tString } = useAppText();

  const initialValues = {
    sourceUid: sourceUid,
    targetEmailAddress: targetEmailAddress
  } as Rattachement;

  return (
    <>
    <AppCol md={8}>
      <label>{tString("migration.step.1.saisie.password")}</label>
    </AppCol>
    <AppCol md={4}>
      <AppFormik
        enableReinitialize
        initialValues={initialValues}
        submitFormAPI={(values: Rattachement) => rattacher(values)}
        submitSuccessHandler={submitSuccessHandler}
        validationSchema={validationSchema}
      >
        <RattachementFormContent />
      </AppFormik>
    </AppCol>
    </>
  );
};

export default RattachementForm;